import Fetch from "."

export const getTemplates = async (filters) => {
  const filter = new URLSearchParams(filters).toString();
  return Fetch(`/trigger-template?${filter}`);
}

export const getTemplate = async (id) => {
  return Fetch(`/trigger-template/${id}`);
}

export const createTemplate = async (body) => {
  return Fetch(
    `/trigger-template/`,
    {
      method: 'POST',
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
      }
    },
  );
}

export const updateTemplate = async (id, body) => {
  return Fetch(
    `/trigger-template/${id}`,
    {
      method: 'PUT',
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
      }
    },
  );
}


export const deleteTemplate = async (id) => {
  return Fetch(
    `/trigger-template/${id}`,
    {
      method: 'DELETE',
      headers: {
        "Content-Type": "application/json",
      }
    },
  );
}



